import React from 'react';
import strings from 'localization/strings';
import { useScrollToTop } from 'helpers/BrowserHelper';

import Container from 'common/Container';
import PageTitle from 'common/PageTitle';
import MarginBox from 'common/MarginBox';
import Typography from '@material-ui/core/Typography';
import FaqSection from 'components/faq/FaqSection';

const FaqPage = () => {
    useScrollToTop();

    return (
        <Container withPageMargins>
            <PageTitle>{strings.faqHeading}</PageTitle>

            <MarginBox bottom={4}>
                <Typography variant="h1">{strings.faqHeading}</Typography>
            </MarginBox>
            <MarginBox bottom={4}>
                <Typography variant="body1">{strings.faqBody}</Typography>
            </MarginBox>

            <FaqSection />
        </Container>
    );
};

export default FaqPage;
